let cameras = {
  'Versa Series': ['VersaX 120', 'VersaX 120N', 'VersaX 120W', 'VersaX 41', 'VersaX 41N', 'VersaX 41W', 'VersaX 22', 'VersaX 22W'],
  'Prime Series': ['Prime 13', 'Prime 13W', 'Prime 17W', 'Prime 41', 'PrimeX 13', 'PrimeX 13W', 'PrimeX 22', 'PrimeX 41', 'PrimeX 41W',  'PrimeX 120', 'PrimeX 120W', 'Prime Color'],
  'Flex Series': ['Flex 3', 'Flex 13'],
  'Slim Series': ['Slim 3U', 'Slim 13E', 'SlimX13', 'SlimX120'],
  'Tracking Bar Series': ["Duo 3 (V120:Duo)", "Trio 3 (V120:Trio)"]
}

let accessories = {
  "Active Components": ['Active Base Station','Active HMD Clip','Active Puck','Active Tag', 'AnchorPuck', 'CinePuck','Wired CinePuck'],
  "License Keys": ['Hardware Key', 'Security Key'],
  "Calibration Tools": ['Active Calibration Square', 'Active Calibration Wand', 'Calibration Square','Calibration Wand'],
  "Sync & Networking": ['eSync', 'OptiHub']
}

let software = {
  "Licensing": ['License', 'Software Activation'],
  "Applications": ['Motive:Tracker', 'Motive:Body', 'Arena', 'Tracking Tools', 'Expression'],
  "Developer Tools": ['Active Batch Processor','Camera SDK','Motive API','NatNet SDK'],
  "Plugins": ['Glove Plugin', 'MotionBuilder Plugin', 'Open VR Driver', 'Unreal Engine Plugin', 'Unity Plugin']
}


addOptionsGroup = (sel, lab, opts) => {
  var i,
      len = opts.length, opt,
      gr = document.createElement('OPTGROUP');

  gr.label = lab;
  for(i=0; i < len; i++) {
    opt = document.createElement('OPTION');
    opt.textContent = opts[i];
    opt.value = opts[i];
    gr.appendChild(opt);
  }
  sel.appendChild(gr);
  return gr;
}

buildSelect = (productsList) => {
  /* Reference product select element */
  var sel = document.getElementById('00NS60000026vLq');

  sel.innerHTML = "";

  let def = document.createElement('OPTION');
  let other = document.createElement('OPTION');
  def.disabled = true;
  def.selected = true;
  def.textContent = 'Select Camera';
  def.value = "";
  if(productsList === accessories) {
    def.textContent = 'Select Accessory';
  }
  if(productsList === software) {
    def.textContent = 'Select Software';
  }

  other.textContent = 'Other';
  other.value = 'Other';

  sel.appendChild(def);
  sel.appendChild(other);

  for(const [key, value] of Object.entries(productsList)) {

    let curKey = '';
    if(curKey != key) {
      curKey = key;
      addOptionsGroup(sel, curKey, value);
    }
  }
}

categoryUpdate = (cat) => {
  switch (cat) {
    case 'Cameras':
      buildSelect(cameras);
      break;
    case 'Accessories':
      buildSelect(accessories);
      break;
    case 'Software':
      buildSelect(software);
      break;
  }
}

countryUpdate = (country) => {
  /* Reference the state form group */
  let stateFormGroup = document.getElementById('stateFormGroup');
  let stateSel = document.getElementById('00N1T00000AvRf6');

  if(country ==='United States') {
    stateFormGroup.classList.remove('hide');
  } else {
    stateFormGroup.classList.add('hide');
    stateSel.value = '';
  }
}


window.onload = () => {
  /* Reference category select element */
  let catSelect = document.getElementById('00NS60000026vJ5');

  /* Load initial data */
  categoryUpdate(catSelect.value);

  catSelect.onchange = () => {
    categoryUpdate(catSelect.value);
  }

  /* Combine the first and last name fields and put into the name field
      The endpoint is expecting this combined field instead of first and last names
  */
  let name = document.getElementById('name');
  let fnameTxt = document.getElementById('fname');
  let lnameTxt = document.getElementById('lname');
  fnameTxt.oninput = () => {
    name.value = fnameTxt.value + " " + lnameTxt.value;
  }
  lnameTxt.oninput = () => {
    name.value = fnameTxt.value + " " + lnameTxt.value;
  }

  /* Reference the country select element */
  let countrySelect = document.getElementById('00N1T00000AvRf1');
  countrySelect.onchange = () => {
    countryUpdate(countrySelect.value);
  }

}

